"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaCosmWasmService = exports.AccessType = exports.AccessConfig = void 0;
var cosmwasm_1 = require("./firmachain/cosmwasm");
var encoding_1 = require("@cosmjs/encoding");
var FirmaUtil_1 = require("./FirmaUtil");
var pako_1 = __importDefault(require("pako"));
var long_1 = __importDefault(require("long"));
var types_1 = require("cosmjs-types/cosmwasm/wasm/v1/types");
Object.defineProperty(exports, "AccessConfig", { enumerable: true, get: function () { return types_1.AccessConfig; } });
Object.defineProperty(exports, "AccessType", { enumerable: true, get: function () { return types_1.AccessType; } });
var FirmaCosmWasmService = /** @class */ (function () {
    function FirmaCosmWasmService(config) {
        this.config = config;
    }
    FirmaCosmWasmService.prototype.getTxClient = function (wallet) {
        return new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
    };
    FirmaCosmWasmService.prototype.getGasEstimationStoreCode = function (wallet, wasmCode, accessConfig, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxStoreCode(wallet, wasmCode, accessConfig, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.storeCode = function (wallet, wasmCode, accessConfig, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, bankTxClient, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxStoreCode(wallet, wasmCode, accessConfig, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        bankTxClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, bankTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getGasEstimationUpdateAdmin = function (wallet, contractAddress, adminAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxUpdateAdmin(wallet, contractAddress, adminAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.updateAdmin = function (wallet, contractAddress, adminAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, bankTxClient, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxUpdateAdmin(wallet, contractAddress, adminAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        bankTxClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, bankTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getGasEstimationClearAdmin = function (wallet, contractAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxClearAdmin(wallet, contractAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.clearAdmin = function (wallet, contractAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, bankTxClient, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxClearAdmin(wallet, contractAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        bankTxClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, bankTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getGasEstimationMigrateContract = function (wallet, contractAddress, codeId, msg, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxMigrateContract(wallet, contractAddress, codeId, msg, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.migrateContract = function (wallet, contractAddress, codeId, msg, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, bankTxClient, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxMigrateContract(wallet, contractAddress, codeId, msg, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        bankTxClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, bankTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getGasEstimationExecuteContract = function (wallet, contractAddress, msg, funds, txMisc) {
        if (funds === void 0) { funds = []; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxExecuteContract(wallet, contractAddress, msg, funds, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.executeContract = function (wallet, contractAddress, msg, funds, txMisc) {
        if (funds === void 0) { funds = []; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, bankTxClient, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxExecuteContract(wallet, contractAddress, msg, funds, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        bankTxClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, bankTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.signAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.signAndBroadcast(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getGasEstimationSignAndBroadcast = function (wallet, msgList, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, txRaw, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign(msgList, FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getGasEstimationInstantiateContract = function (wallet, admin, codeId, label, msg, funds, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxInstantiateContract(wallet, admin, codeId, label, msg, funds, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.instantiateContract = function (wallet, admin, codeId, label, msg, funds, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, bankTxClient, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxInstantiateContract(wallet, admin, codeId, label, msg, funds, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        bankTxClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, bankTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getSignedTxInstantiateContract = function (wallet, admin, codeId, label, msg, funds, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, utfMsg, message, txClient, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        utfMsg = encoding_1.toUtf8(msg);
                        message = cosmwasm_1.CosmWasmTxClient.msgInstantiateContract({ sender: address, admin: admin, codeId: long_1.default.fromString(codeId), label: label, msg: utfMsg, funds: funds });
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getSignedTxUpdateAdmin = function (wallet, contractAddress, adminAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, txClient, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = cosmwasm_1.CosmWasmTxClient.msgUpdateAdmin({ sender: address, contract: contractAddress, newAdmin: adminAddress });
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_16 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_16);
                        throw error_16;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getSignedTxClearAdmin = function (wallet, contractAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, txClient, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = cosmwasm_1.CosmWasmTxClient.msgClearAdmin({ sender: address, contract: contractAddress });
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_17 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_17);
                        throw error_17;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getSignedTxMigrateContract = function (wallet, contractAddress, codeId, msg, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, utfMsg, message, txClient, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        utfMsg = encoding_1.toUtf8(msg);
                        message = cosmwasm_1.CosmWasmTxClient.msgMigrateContract({ sender: address, contract: contractAddress, codeId: long_1.default.fromString(codeId), msg: utfMsg });
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_18 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_18);
                        throw error_18;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getUnsignedTxExecuteContract = function (wallet, contractAddress, msg, funds) {
        return __awaiter(this, void 0, void 0, function () {
            var address, utfMsg, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        utfMsg = encoding_1.toUtf8(msg);
                        return [2 /*return*/, cosmwasm_1.CosmWasmTxClient.msgExecuteContract({ sender: address, contract: contractAddress, msg: utfMsg, funds: funds })];
                    case 2:
                        error_19 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_19);
                        throw error_19;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getSignedTxExecuteContract = function (wallet, contractAddress, msg, funds, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, utfMsg, message, txClient, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        utfMsg = encoding_1.toUtf8(msg);
                        message = cosmwasm_1.CosmWasmTxClient.msgExecuteContract({ sender: address, contract: contractAddress, msg: utfMsg, funds: funds });
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_20 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_20);
                        throw error_20;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getSignedTxStoreCode = function (wallet, wasmCode, accessConfig, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, compressed, message, txClient, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        compressed = pako_1.default.gzip(wasmCode, { level: 9 });
                        message = cosmwasm_1.CosmWasmTxClient.msgStoreCode({ sender: address, wasmByteCode: compressed, instantiatePermission: accessConfig });
                        txClient = new cosmwasm_1.CosmWasmTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_21 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_21);
                        throw error_21;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // query
    FirmaCosmWasmService.prototype.getCodeList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getCodeInfoList()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_22 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_22);
                        throw error_22;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getCodeData = function (codeId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getCodeData(codeId)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_23 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_23);
                        throw error_23;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getContractListFromCodeId = function (codeId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_24;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getContractListFromCodeId(codeId)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_24 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_24);
                        throw error_24;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getContractInfo = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_25;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getContractInfo(contractAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_25 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_25);
                        throw error_25;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getContractHistory = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_26;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getContractHistory(contractAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_26 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_26);
                        throw error_26;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getContractRawQueryData = function (contractAddress, hexString) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_27;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getContractRawQueryData(contractAddress, hexString)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_27 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_27);
                        throw error_27;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getContractSmartQueryData = function (contractAddress, query) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_28;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getContractSmartQueryData(contractAddress, query)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_28 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_28);
                        throw error_28;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getContractState = function (contractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_29;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getContractState(contractAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_29 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_29);
                        throw error_29;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaCosmWasmService.prototype.getPinnedCodeList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_30;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new cosmwasm_1.CosmWasmQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getPinnedCodeList()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_30 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_30);
                        throw error_30;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaCosmWasmService;
}());
exports.FirmaCosmWasmService = FirmaCosmWasmService;
